import { ArrowRight, Delete } from "lucide-react";

const TECLAS = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

export default function Teclado({ onTecla, onBorrar, onEnter }) {
  const btn = "flex h-12 items-center justify-center gap-1.5 rounded-xl border transition-all active:scale-95";
  const digito = `${btn} border-white/10 bg-[#1B212B] text-lg font-semibold text-white hover:border-[#2DD4BF]/60 hover:bg-[#2DD4BF]/10`;
  return (
    <div className="grid grid-cols-3 gap-2" data-testid="kiosco-teclado">
      {TECLAS.map((t) => (
        <button key={t} type="button" onClick={() => onTecla(t)} data-testid={`tecla-${t}`} className={digito}>
          {t}
        </button>
      ))}
      <button
        type="button"
        onClick={onBorrar}
        data-testid="tecla-borrar"
        className={`${btn} border-white/10 bg-[#1B212B]/60 text-xs font-medium text-gray-400 hover:border-red-400/50 hover:text-red-300`}
      >
        <Delete size={16} /> Borrar
      </button>
      <button type="button" onClick={() => onTecla("0")} data-testid="tecla-0" className={digito}>
        0
      </button>
      <button
        type="button"
        onClick={onEnter}
        data-testid="tecla-siguiente"
        className={`${btn} border-[#2DD4BF] bg-[#2DD4BF] text-sm font-bold text-black hover:brightness-110`}
      >
        Seguir <ArrowRight size={16} />
      </button>
    </div>
  );
}
